module.exports = __webpack_public_path__ + "img/9cfae59.jpg";